import { useMutation } from 'react-query'
import axios, { AxiosResponse } from 'axios'
import { getAPIUrl } from '../../api/API'
import { Person } from './CreditReportById'

export type CreditReportCandidateRequest = {
  identityNumber: string
  passportNumber: string
  firstName: string
  lastName: string
  dateOfBirth?: string | null
  purpose: string
  reference: string
  productId: number
  reportType: number
}

export const useCreditReportCandidateSearch = (
  values: CreditReportCandidateRequest,
  setCreditSearchResults: (value: Person[]) => void,
  handleError: (e: any) => void,
) => {
  const { mutate: searchCreditReportCandidate, isLoading } = useMutation(
    'credit-candidate',
    async () => {
      const res = await axios.post<any, AxiosResponse<{ data: Person[] }>>(
        getAPIUrl() + '/Common/search-consumer',
        {
          identityNumber: values.identityNumber,
          passportNumber: values.passportNumber ?? undefined,
          firstName: values.firstName,
          lastName: values.lastName,
          dateOfBirth: values.dateOfBirth,
          purpose: values.purpose,
          reference: values.reference,
          productId: 15,
          reportType: 1,
        },
        {
          headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
          },
        },
      )
      return res.data
    },
    {
      onSuccess: (response) => {
        setCreditSearchResults(response.data)
      },
      onError: handleError,
    },
  )

  return {
    searchCreditReportCandidate,
    isLoading,
  }
}
function setCreditSearchResults(data: Person[]) {
  throw new Error('Function not implemented.')
}
